import React from 'react';
import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd';
import { DatePickerProps as AntdDatePickerProps } from 'antd/es/date-picker';
import moment from "moment";
import "moment/locale/ko";
import locale from "antd/lib/locale/ko_KR";

const DatePicker = ({ ...rest }: AntdDatePickerProps): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <ConfigProvider locale={locale}>
      <AntdDatePicker
        {...rest}
      />
    </ConfigProvider>
  );
};

export default DatePicker;
